import slice from "./dataExportSlice";

export default slice.reducer;
